export default "__VITE_ASSET__WKJjHMDv__"